<div class="billing-page">

    <!-- HEADER -->
    <div class="billing-header">
        <div>
            <h2>Invoices</h2>
            <p>Manage billing, payments & history</p>
        </div>

        <div class="actions">
            <button class="btn btn-primary">+ Create Invoice</button>
            <button class="btn btn-outline">Export</button>
        </div>
    </div>

    <!-- KPI -->
    <div class="kpi-row">

        <div class="kpi">
            <span>Total Revenue</span>
            <b>{{ stats.totalRevenue }}</b>
        </div>

        <div class="kpi">
            <span>Collected</span>
            <b class="green">{{ stats.paid }}</b>
        </div>

        <div class="kpi">
            <span>Outstanding</span>
            <b class="orange">{{ stats.pending }}</b>
        </div>

        <div class="kpi">
            <span>Overdue</span>
            <b class="red">{{ stats.overdue }}</b>
        </div>

    </div>

    <!-- FILTER BAR -->
    <div class="toolbar">

        <input placeholder="Search invoice..." [(ngModel)]="q" />

        <select [(ngModel)]="status">
            <option value="">All</option>
            <option>PAID</option>
            <option>OPEN</option>
            <option>FAILED</option>
            <option>OVERDUE</option>
        </select>

        <input type="date" [(ngModel)]="from" />
        <input type="date" [(ngModel)]="to" />

        <button class="btn btn-soft">Reset</button>

    </div>

    <!-- VIEW TOGGLE -->
    <div class="view-toggle">
        <button (click)="view='table'">Table</button>
        <button (click)="view='grid'">Grid</button>
    </div>

    <!-- TABLE VIEW -->
    <div *ngIf="view === 'table'" class="table-wrap">

        <table>
            <thead>
                <tr>
                    <th>Invoice</th>
                    <th>Customer</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Total</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let i of invoices">

                    <td>#{{ i.invoiceNo }}</td>

                    <td>{{ i.patientId?.fullName }}</td>

                    <td>
                        <span class="pill" [ngClass]="i.status.toLowerCase()">
                            {{ i.status }}
                        </span>
                    </td>

                    <td>{{ i.createdAt | date }}</td>

                    <td>{{ i.currency }} {{ i.grandTotal }}</td>

                    <td>
                        <button (click)="openInvoice(i._id)">View</button>
                    </td>

                </tr>
            </tbody>

        </table>

    </div>

</div>



<div class="invoice-detail" *ngIf="invoice">

    <div class="header">
        <h3>Invoice #{{ invoice.invoiceNo }}</h3>

        <div class="actions">
            <button>Download PDF</button>
            <button>Send</button>
            <button *ngIf="invoice.status === 'FAILED'">
                Retry Payment
            </button>
        </div>
    </div>

    <div class="status-line">
        <span class="pill">{{ invoice.status }}</span>
        <span>Created: {{ invoice.createdAt | date }}</span>

        <span *ngIf="invoice.paidAt">
            Paid: {{ invoice.paidAt | date }}
        </span>
    </div>

    <div class="grid">

        <div>
            <label>Customer</label>
            <div>{{ invoice.patientId?.fullName }}</div>
        </div>

        <div>
            <label>Payment Method</label>
            <div>{{ invoice.paymentSource }}</div>
        </div>

        <div>
            <label>Order</label>
            <div>{{ invoice.orderId?.orderNo }}</div>
        </div>

    </div>

    <div class="breakdown">
        <div>Subtotal: {{ invoice.subTotal }}</div>
        <div>Discount: -{{ invoice.discountAmount }}</div>

        <hr>

        <b>Total: {{ invoice.grandTotal }}</b>
    </div>

</div>